
import React from 'react';
import { Result, Button } from 'antd';

const RegistrationConfirmationPage = () => {
  return (
    <div style={{ position: 'relative', height: '50vh' }}>
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
        <Result
          status="success"
          title="Successfully Registered!"
          subTitle="Welcome to our community! We're glad to have you here."
          extra={[
            <Button type="primary" key="console">
              Go to Dashboard
            </Button>,
          ]}
        />
      </div>
    </div>
  );
};

export default RegistrationConfirmationPage;
